var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 60,
    viewBox: "0 0 103 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.5 60L52.5 11.5L0.5 60H102.5Z",
    fill: "url(#paint0_linear_318_2666)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8614 59.9996L52.56 0.285156L14.25 59.9996H90.8614Z",
    fill: "url(#paint1_linear_318_2666)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8614 59.9971L70.6682 28.3576L52.56 11.1406L34.4519 28.3576L14.25 59.9971H90.8614Z",
    fill: "url(#paint2_linear_318_2666)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M52.5609 0L18.6113 60H86.5017L52.5609 0Z",
    fill: "url(#paint3_linear_318_2666)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5609 3.78947L84.3561 60H86.5017L52.5609 0L18.6113 60H20.757L52.5609 3.78947Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9258 51.6343L52.5602 15.1758L73.1861 51.6343H31.9258Z",
    fill: "url(#paint4_linear_318_2666)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0918 51.6312L52.5597 20.7617L70.019 51.6312H35.0918Z",
    fill: "url(#paint5_linear_318_2666)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M41.4258 51.6351L52.5606 31.9609L63.6868 51.6351H41.4258Z",
    fill: "url(#paint6_radial_318_2666)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_2666",
    x1: 51.6258,
    y1: 12.8894,
    x2: 51.6258,
    y2: 75.8911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_2666",
    x1: 52.56,
    y1: 1.55697,
    x2: 52.56,
    y2: 60.9254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CCE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_2666",
    x1: 52.56,
    y1: 15.9337,
    x2: 52.56,
    y2: 60.1183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_2666",
    x1: 52.5609,
    y1: -0.0865177,
    x2: 52.5609,
    y2: 58.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_2666",
    x1: 52.5602,
    y1: 51.6862,
    x2: 52.5602,
    y2: 16.1015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_2666",
    x1: 52.5597,
    y1: 21.7567,
    x2: 52.5597,
    y2: 50.5671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_318_2666",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5606 41.798) scale(10.5032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875C13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.6ea356e5ba944ab70d08b73cc25e6133.svg";
export { ForwardRef as ReactComponent };